import { LIST_IMPORTED_EXAMS, SET_IMPORTED_EXAMS, SET_LAST_IMPORTED_AT } from '@actions/exam'

const defaultState = {
  labExams: null,
  labExamsPage: 0,
  labExamsLast: false,
  labExamsTotal: 0,
  lastImportedAt: null,
}

const examReducer = (state = defaultState, action) => {
  switch (action.type) {
    case LIST_IMPORTED_EXAMS:
      return {
        ...state,
      }
    case SET_IMPORTED_EXAMS: {
      const {
        content, page, last, total, append,
      } = action.payload
      return {
        ...state,
        labExams: append && Array.isArray(state.labExams)
          ? [...state.labExams, ...content]
          : content,
        labExamsPage: page,
        labExamsLast: last,
        labExamsTotal: total,
      }
    }
    case SET_LAST_IMPORTED_AT: {
      const { payload } = action
      return {
        ...state,
        lastImportedAt: payload
      }
    }
    default:
      return state
  }
}

export default examReducer
